export default {
    Title: 'Tham số báo cáo',
    Year: 'Năm',
    All: 'Tất cả',
    Activity: 'Hoạt động',
    AccountNumber: 'Tài khoản',
    IsRepeatTitle: 'Lặp tiêu đề cột',
    OptionsGetData: 'Tùy chọn lấy số liệu',
    SetupFormula: 'Thiết lập công thức',
    DisplayOption: 'Tùy chọn hiển thị',
    ChoosePeriod: 'Chọn kỳ báo cáo',
    SelectAll: '<<Tất cả>>',
  };
  